import { Badge } from "antd";

const PaymentStatus = ({ paymentStatus }) => {
    switch (paymentStatus) {
        case "Cancel":
            return (
                <Badge color="#F15046" style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} text={paymentStatus} />
            )
        case "ยกเลิก":
            return (
                <Badge color="#F15046" style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} text={paymentStatus} />
            )
        case "Pending Calculation":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "รอการคำนวณ":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "Pending Verification":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "รอตรวจสอบ":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "Pending Approval":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "รออนุมัติ":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "Pending Close":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "รอปิดงวด":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "Pending Payment":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "รอชำระเงิน":
            return (
                <Badge color="#FFBF1A" style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} text={paymentStatus} />
            )
        case "Paid":
            return (
                <Badge color="#12B76A" style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} text={paymentStatus} />
            )
        case "ชำระเงินแล้ว":
            return (
                <Badge color="#12B76A" style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} text={paymentStatus} />
            )
        case "Upcoming":
            return (
                <Badge color="#667085" style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} text={paymentStatus} />
            )
        case "ยังไม่ถึงงวดชำระ":
            return (
                <Badge color="#667085" style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} text={paymentStatus} />
            )
        default:
            return (<Badge color="#667085" style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} text={paymentStatus} />)
    }
}

export default PaymentStatus;